import React from 'react';
import { Alert, EmptyText, FieldGroup, Row, Stack, Text, TextArea, TextInput } from 'library/ui';
import { useFaqQuestions } from './jobFaqQuestionsApi';
import { JobFaq } from 'parent-portal/forms/JobRequestTypes';

export default function JobFaqForm({ faqs, setFaqs }: { faqs: JobFaq[]; setFaqs: (newValue: JobFaq[]) => void }) {
    const { data, loading } = useFaqQuestions();

    const updateFaqs = (value: string, questionId: number) => {
        setFaqs([
            ...faqs.filter((it) => it.question.id !== questionId),
            ...(value ? [{ question: { id: questionId }, answer: value }] : []),
        ]);
    };

    return (
        <Stack gap="md">
            <Alert variant="info">
                <Row gap="sm" align="center">
                    <Text size="md" lineHeight="relaxed">
                        <Text size="md" weight="bold">
                            This info will be shared with the confirmed Tandem teacher.
                        </Text>{' '}
                        The more info we can share with the teacher the better! This will prepare them for their shift
                        and allow them to meet your expectations.
                    </Text>
                </Row>
            </Alert>
            {loading && <EmptyText>Loading...</EmptyText>}
            <Stack gap="md">
                {data?.map((question) => {
                    const value = faqs?.find((fieldVal) => fieldVal.question.id === question.id)?.answer ?? '';
                    return (
                        <FieldGroup key={question.id} label={question.question}>
                            {question.multiline ? (
                                <TextArea
                                    fullWidth
                                    minRows={2}
                                    value={value}
                                    onChange={(newValue) => updateFaqs(newValue, question.id)}
                                />
                            ) : (
                                <TextInput
                                    fullWidth
                                    value={value}
                                    onChange={(newValue) => updateFaqs(newValue, question.id)}
                                />
                            )}
                        </FieldGroup>
                    );
                })}
            </Stack>
        </Stack>
    );
}
